/**
 * Who may READ invoice data (#1315) — the client-side mirror of staff-api's
 * `INVOICE_READ_PERMISSIONS` (`services/staff-api/src/lib/invoice-permissions.ts`).
 *
 * Holding ANY of these grants read access. Keep the two lists in sync: the API
 * is the enforcement point, this one only decides what to render and which
 * queries to fire, so a stale copy here means either a dead nav item or a
 * pointless 403.
 */
export const INVOICE_READ_PERMISSIONS = [
  'invoices.manage',
  'payments.take',
  'receipts.read',
  'reports.view_financial',
];
